<template>
  <div class="page-content">
    <a-spin :spinning="loading" tip="加载中..." size="large">
      <div class="main-content">

        <a-card style="width: 100%" size="small" title="订单信息" class="mt-10">
          <div style="display: flex;">
            <Cell label="经办校区" :value="orderDetail.schoolName" />
          </div>
          <Cell label="订单备注" :value="orderDetail.remark" v-if="orderDetail.remark" />
        </a-card>


        <a-card style="width: 100%" size="small" title="课程信息" class="mt-10">
          <div v-for="course in orderDetail.studyCourseList" :key="course.orderCourseId">
            <div class="courseTitle">
              <span style="margin-right: 7px;">{{ course.courseName }}</span>
              <a-tag color="red">{{ selectDictLabel(gradeList, course.grade) }}</a-tag>
              <a-tag color="blue">{{ selectDictLabel(subjectList, course.subject) }}</a-tag>
            </div>
            <div style="font-size: 12px">
              <Cell label="课程原价" :value="'￥' + course.coursePay" />
              <div style="padding: 10px 15px;">购买课时：{{ course.buyClassHourCount }}
                <span style="color: red;" v-if="course.giftClassHourCount">赠送（{{ course.giftClassHourCount }}）</span>

              </div>
              <Cell label="优惠后金额" :value="'￥' + getPayAmount(course)" />
            </div>
          </div>
        </a-card>

        <a-card style="width: 100%" size="small" title="支付信息" class="mt-10">
          <Cell label="订单原价" :value="'¥' + orderDetail.courseAmount" />
          <div style="display: flex;">
            <Cell label="应收" :value="'¥' + orderDetail.shouldPay" />
            <Cell label="优惠金额" :value="'¥' + orderDetail.preferentialAmount" />
          </div>
          <Cell label="本次支付金额" style="display: flex; align-items: center;">
            <span style="color: red; font-size: 20px;">¥{{ orderDetail.amount }}</span>
          </Cell>
        </a-card>
        <!-- 添加底部空间，确保内容不会被底部按钮遮挡 -->
        <div style="height: 80px;"></div>
      </div>
    </a-spin>
    
    <!-- 将底部按钮移出spin组件，确保它始终可见 -->
    <div class="page-content-footer" v-if="!loading && orderDetail.arrearage > 0">
      <a-button type="primary" style="width: 95%;height: 50px;margin-left: 3%;" @click="confirm">支付</a-button>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import Cell from '@/component/cell.vue'
import { getOrderForCustomer, getOpenidByCode } from '@/api/order'
import { useRoute, useRouter } from 'vue-router';
import { useDict, selectDictLabel } from '@/utils/dict'

const route = useRoute()
const router = useRouter()
const {
  grade_list: gradeList,
  course_subject: subjectList
} = useDict(
  'grade_list',
  'course_subject'
)

const loading = ref(true)
const orderDetail = ref({})
const paymentOrderId = ref()
const openid = ref('')
const code = ref()

onMounted(() => {
  paymentOrderId.value = route.params.paymentOrderId
  openid.value = localStorage.getItem('openid')
  if (!openid.value && route.query.code) {
    code.value = route.query.code
    getOpenidByCode(code.value).then(response => {
      openid.value = response
      localStorage.setItem('openid', response)
    })
  }
  initData()
})

function initData() {
  loading.value = true
  getOrderForCustomer(paymentOrderId.value).then(response => {
    if (response.payStatus === 3) {
      router.push({ path: '/paySuccess' })
    }
    orderDetail.value = response
  }).finally(() => {
    loading.value = false
  })
}


function getPayAmount(course) {
  let payAmount = course.coursePay
  if (orderDetail.value.discountRate && orderDetail.value.discountRate != 0) {
    payAmount = payAmount * (orderDetail.value.discountRate / 10)
  }
  if (course.reductionAmount) {
    payAmount = payAmount - Number(course.reductionAmount)
  }
  return payAmount
}

function confirm() {
  router.push({
    name: 'ContractAgreement',
    query: { paymentOrderId: paymentOrderId.value, contract_no: orderDetail.value.orderId, openid: openid.value, phone: orderDetail.value.phone }
  })
}

</script>

<style scoped>
.page-content {
  background-color: #f0f2f5;
  min-height: 100vh;
  padding-bottom: 80px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
}

.main-content {
  padding: 10px;
  min-height: calc(100vh - 80px);
}

.flex-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-box .left {
  flex: 1;
}

.page-content-title {
  text-align: center;
  padding: 10px;
}

.address {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}

.mt-10 {
  margin-top: 10px;
}

.courseInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-content-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: transparent;
  padding: 10px;
  z-index: 10;
}

.courseTitle {
  color: #1890ff;
  display: flex;
  align-items: center;
}

.courseTitle::before {
  content: '';
  display: inline-block;
  width: 3px;
  height: 15px;
  background: #1890ff;
  margin-right: 5px;
}
</style>
